import API from '../dataApi';

// -- Derasar Persons --------------------------------------------------------
export const getDerasarPersons = (derasarId) => API.get('/derasar-persons', { params: { derasarId } });
export const getDerasarPersonUsers = (derasarId) => API.get('/derasar-persons/users', { params: { derasarId } });
export const getDerasarPersonsAdmin = (derasarId) => API.get('/derasar-persons/admin', { params: { derasarId } });
export const createDerasarPerson = (data) => API.post('/derasar-persons', data);
export const updateDerasarPerson = (id, data) => API.put(`/derasar-persons/${id}`, data);
export const deleteDerasarPerson = (id) => API.delete(`/derasar-persons/${id}`);
export const getMemberDirectory = (derasarId) =>
  API.get('/derasar-persons/directory', { params: { derasarId } });
